// extracted by mini-css-extract-plugin
module.exports = {"confirmation__calendarButton":"AddToGoogleCalendarButton_confirmation__calendarButton__3g_0M"};